import React from 'react';

import { RowProps } from 'antd/lib/grid';

export type GridContextType = {
  gutter: RowProps['gutter'];
};

export const gridContextDefaults: GridContextType = {
  gutter: { xs: 10, sm: 16 },
};

export const GridContext =
  React.createContext<GridContextType>(gridContextDefaults);
